import WebPushHelper from './helper'

/**
 * Ensure to set or copy the worker from this plugin to a public folder
 */
export default {
	install(Vue, {
		key,
		file,
		scope,
	}) {
		const webPush = new WebPushHelper(key, file, scope)
		Vue.prototype.$webpush = webPush
		webPush.init()
	},
}
